'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentDiscoverAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M27.6171 29.4675C27.6171 33.0085 30.3942 35.7541 33.9682 35.7541C34.9784 35.7541 35.844 35.5553 36.9109 35.0522V32.2861C35.9728 33.2263 35.1416 33.6056 34.0775 33.6056C31.7136 33.6056 30.0358 31.8896 30.0358 29.4498C30.0358 27.1371 31.7666 25.3126 33.9682 25.3126C35.0877 25.3126 35.9351 25.7124 36.9109 26.6679V23.9032C35.8807 23.3801 35.0337 23.1632 34.0236 23.1632C30.4677 23.1632 27.6171 25.9646 27.6171 29.4675ZM21.5938 26.5416C21.5938 27.1928 22.0071 27.5367 23.4157 28.0585C26.0855 29.0364 26.8767 29.9025 26.8767 31.8168C26.8767 34.1487 25.1655 35.7726 22.7267 35.7726C20.9407 35.7726 19.6418 35.0684 18.5605 33.4789L20.0769 32.017C20.6171 33.0633 21.519 33.6241 22.6384 33.6241C23.6858 33.6241 24.4607 32.9008 24.4607 31.9248C24.4607 31.4189 24.226 30.9847 23.7569 30.6779C23.5212 30.5327 23.0535 30.3168 22.1345 29.9919C19.93 29.1979 19.1741 28.348 19.1741 26.6882C19.1741 24.7167 20.7979 23.2366 22.9271 23.2366C24.2464 23.2366 25.4537 23.6881 26.463 24.5719L25.2347 26.1819C24.6234 25.4958 24.0451 25.2063 23.3422 25.2063C22.3307 25.2063 21.5938 25.783 21.5938 26.5416ZM15.3294 35.4829H17.6766V23.4356H15.3294V35.4829ZM10.5319 32.4855C9.79459 33.1525 8.83648 33.4434 7.32004 33.4434H6.69013V25.4766H7.32004C8.83648 25.4766 9.75694 25.7484 10.5319 26.4512C11.3436 27.1745 11.8317 28.2962 11.8317 29.45C11.8317 30.6066 11.3436 31.7623 10.5319 32.4855ZM7.79003 23.4357H4.34482V35.4825H7.7719C9.59423 35.4825 10.9098 35.0524 12.0651 34.0917C13.4378 32.9547 14.2495 31.2405 14.2495 29.4677C14.2495 25.9122 11.5965 23.4357 7.79003 23.4357ZM52.3121 23.4356L55.5207 31.5276L58.7711 23.4356H61.3154L56.1171 35.7919H54.8541L49.7478 23.4356H52.3121ZM62.3767 35.4826H69.0329V33.4431H64.722V30.1911H68.8743V28.1507H64.722V25.4768H69.0329V23.4354H62.3767V35.4826ZM72.9317 28.9818H73.6174C75.1166 28.9818 75.9111 28.3297 75.9111 27.1187C75.9111 25.9463 75.1166 25.3333 73.6545 25.3333H72.9317V28.9818ZM74.0678 23.4353C76.7744 23.4353 78.3261 24.7366 78.3261 26.9921C78.3261 28.8366 77.3527 30.0476 75.5847 30.4074L79.373 35.4825H76.4866L73.238 30.6429H72.9317V35.4825H70.5873V23.4353H74.0678Z",
          fill: "#1D1D1B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M49.4709 32.9539C51.3759 29.9715 50.5059 26.0096 47.5275 24.1025C44.549 22.1955 40.591 23.0661 38.686 26.0484C36.7814 29.03 37.6518 32.9932 40.6302 34.9003C43.6086 36.8073 47.5664 35.9354 49.4709 32.9539Z",
          fill: "url(#paint0_linear_647_1942)"
        }
      ),
      /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_647_1942",
          x1: 52.9195,
          y1: 27.555,
          x2: 42.1271,
          y2: 20.6612,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx("stop", { stopColor: "#F6A000" }),
            /* @__PURE__ */ jsx("stop", { offset: 0.623918, stopColor: "#E47E02" }),
            /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#D36002" })
          ]
        }
      ) })
    ]
  }
);
const VpPaymentDiscoverAsset = forwardRef(PaymentDiscoverAsset);

export { VpPaymentDiscoverAsset as default };
